import {
    DASHBOARD_SUMMARY_ERROR,
    DASHBOARD_SUMMARY_SUCCESS,
    DASHBOARD_SUMMARY_REQUEST 
} from '../actions/dashboardSummaryActions';

const initialState={
    data:[],
    fetching:false,
    set:false,  
    needRefresh: false
}

export default function dashboardSummary(state = initialState, action){
    switch (action.type){
        case DASHBOARD_SUMMARY_REQUEST:
            return{
                ...state,
                fetching:true
            }
        case DASHBOARD_SUMMARY_ERROR:
            return{
                ...state,
                fetching:false,
            }
        case DASHBOARD_SUMMARY_SUCCESS:
            return{
                ...state,
                fetching:false,
                set:true,
                data:action.payload
            }
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/dashboardSummary.js